import { render } from "./IconCarousel.vue?vue&type=template&id=6235b9a4"
import script from "./IconCarousel.vue?vue&type=script&lang=js"
export * from "./IconCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__